module.exports = __webpack_public_path__ + "img/icon_map_7_on_010.2817d0b9.png";